import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import FreeCreditEvaluationWrapper from "@components/layouts/freeCreditEvaluationWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <FreeCreditEvaluationWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#0e5aa9" />
                </div>
                <FormSection iconsFillColor="#0e5aa9" />
            </div>
        </FreeCreditEvaluationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
